// extracted by mini-css-extract-plugin
export default {"order":"order_order__jHTfs","order_title":"order_order_title__5zWYb","order_row":"order_order_row__R4wru"};